import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES, setLanguage, type SupportedLang } from '../i18n/index.js';

export function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.language as SupportedLang;

  return (
    <div className="flex items-center gap-1 rounded-md border px-1.5 py-0.5">
      {SUPPORTED_LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          type="button"
          onClick={() => setLanguage(lang.code)}
          className={`rounded px-2 py-0.5 text-xs font-medium transition-colors ${
            current === lang.code ? 'bg-blue-600 text-white' : 'text-gray-500 hover:bg-gray-100'
          }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}
